module.exports = __webpack_public_path__ + "img/bg_light_orange.30690f51.svg";